export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10314.5d6269bf.jpg";